import type { FrameTimingSource } from '../streamRecovery/contracts';

/** Maps actual presentation metadata with paired current clocks, not callback scheduling time. */
export class PresentationTimestampMapper {
  constructor(private readonly options: { wallNowMs: () => number; monotonicNowMs: () => number }) {}

  map(input: { presentationTime?: number }): {
    presentationWallMs: number; observationAgeMs: number; timingSource: FrameTimingSource;
  } {
    const monoNow = this.options.monotonicNowMs();
    const wallNow = this.options.wallNowMs();
    const presentedAt = input.presentationTime;
    if (typeof presentedAt !== 'number' || !Number.isFinite(presentedAt) || presentedAt < 0 ||
        !Number.isFinite(monoNow) || presentedAt > monoNow) {
      return { presentationWallMs: wallNow, observationAgeMs: 0, timingSource: 'callback-time' };
    }
    const observationAgeMs = monoNow - presentedAt;
    return { presentationWallMs: wallNow - observationAgeMs, observationAgeMs, timingSource: 'presentation-time' };
  }
}
